import type { GetFoodImageResponse } from "@tandemdiabetes/sugarmate-api-react-client"

/*
 * this food is used as the placeholder food image response
 *
 * it is not meant to be displayed
 */
export const defaultFoodImageResponse: GetFoodImageResponse = {
  food: {
    image_url: "",
    thumbnail_url: "",
  },
}
